import TpPlatformInvoiceSummaryItem from './TpPlatformInvoiceSummaryItem';

// "Development" sub-tab of the Summarized Invoice Items tab: programming rows carry the
// platform's item count and amount.
export default class TpPlatformInvoiceSummaryDevelopmentItem extends TpPlatformInvoiceSummaryItem {
  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Office',
        orderById: 'OfficeName',
        data: 'OfficeName',
        className: 'text-left',
        minWidth: 60,
      },
      {
        label: 'Caspian Client',
        orderById: 'ClientName',
        data: 'ClientName',
        className: 'text-left',
        minWidth: 80,
      },
      {
        label: 'Count',
        orderById: '',
        data: 'ThirdPartyShopCountApi',
        className: 'text-center',
        minWidth: 40,
      },
      {
        label: 'Amount',
        orderById: '',
        data: 'TotalAmount',
        className: 'text-right',
        minWidth: 40,
      },
    ];
  }
}
